import * as React from "react";
const SvgPtLabel = () => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.787 7.923c0 .423-.26.72-.873.72h-.99l.36-1.26h.837c.414 0 .666.207.666.54"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16m.326-9.248c0-.999-.693-1.719-2.016-1.719H5.051l-1.8 6.3h1.62l.666-2.34h1.278c1.62 0 2.511-.99 2.511-2.24m2.043-.297L10 12.333h1.62l1.386-4.878h1.557l.405-1.422h-4.86l-.405 1.422z",
    clipRule: "evenodd"
  }
));
export default SvgPtLabel;
